module.exports = __webpack_public_path__ + "img/title.777e2bc4.png";